export default  {
    template: require('../views/guest.page.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/guest/components/guest.page.component.js